/* Pulzena — swatch engine
 * Order: exact COMPOUND match → SPECIAL pattern → single PALETTE → 2-word split.
 * Reads label from child `.sr-only` (Pulzena Liquid outputs it inside each .color-swatch).
 */
(function () {
  var PALETTE = {
    noir: '#111111',
    noire: '#111111',
    blanc: '#F5F5F5',
    blanche: '#F5F5F5',
    argent: '#B8BCC0',
    gris: '#C8C8C8',
    grise: '#C8C8C8',
    bleu: '#1E3A8A',
    bleue: '#1E3A8A',
    rouge: '#B91C1C',
    rose: '#F4C2C2',
    abricot: '#E8A88C',
    vert: '#15803D',
    verte: '#15803D',
    marron: '#5C2E1F',
    orange: '#EA580C',
    or: '#D4AF37',
    dore: '#D4AF37',
    doree: '#D4AF37',
    anthracite: '#2F2F2F',
    kaki: '#4B5320',
    jaune: '#EAB308',
    violet: '#7C3AED'
  };

  // Multi-word names that should render as a SOLID color (not a 50/50 split)
  var COMPOUND = {
    'or rose': '#C89583',
    'marron clair': '#A0633D',
    'marron fonce': '#3E1D14',
    'bleu marine': '#0F1E3F',
    'vert armee': '#4B5320',
    'noir etoile': '#141414',
    'blanc etoile': '#E8E6E1',
    'gris orange': '#B0B0A8',
    'gris rose': '#D1B7B0'
  };

  var SPECIAL = {
    camouflage:
      'radial-gradient(circle at 0% 10%, #6B6B72 0 28%, transparent 30%),' +
      'radial-gradient(circle at 95% 20%, #4A4A52 0 26%, transparent 28%),' +
      'radial-gradient(circle at 15% 95%, #8A8A90 0 26%, transparent 28%),' +
      'radial-gradient(circle at 100% 90%, #404046 0 28%, transparent 30%),' +
      'radial-gradient(circle at 50% 45%, #4A4A52 0 20%, transparent 22%),' +
      'radial-gradient(circle at 60% 100%, #6B6B72 0 22%, transparent 24%),' +
      'radial-gradient(circle at 40% 0%, #8A8A90 0 20%, transparent 22%),' +
      'linear-gradient(#2A2A30, #2A2A30)',
    'arc-en-ciel':
      'linear-gradient(135deg, #EF4444 0%, #F59E0B 20%, #EAB308 40%, #22C55E 60%, #3B82F6 80%, #8B5CF6 100%)',
    arcenciel:
      'linear-gradient(135deg, #EF4444 0%, #F59E0B 20%, #EAB308 40%, #22C55E 60%, #3B82F6 80%, #8B5CF6 100%)',
    chocolat:
      'linear-gradient(135deg, #F0F0F0 0%, #8C8C8C 20%, #1A1A1A 40%, #8C8C8C 60%, #F0F0F0 80%, #1A1A1A 100%)'
  };

  var KITO_SWATCHES = {
    rose:
      'linear-gradient(135deg, #F7C9D7 0%, #F7C9D7 50%, #EC4F9A 50%, #EC4F9A 100%)',
    'rouge bleu':
      'linear-gradient(135deg, #B91C1C 0%, #B91C1C 50%, #1E3A8A 50%, #1E3A8A 100%)',
    'vert noir':
      'linear-gradient(135deg, #111111 0%, #111111 50%, #48DDE2 50%, #48DDE2 100%)',
    'noir gris':
      'linear-gradient(135deg, #111111 0%, #111111 50%, #C8C8C8 50%, #C8C8C8 100%)',
    'violet rose':
      'linear-gradient(135deg, #7C3AED 0%, #7C3AED 50%, #EC4F9A 50%, #EC4F9A 100%)'
  };

  function norm(s) {
    return (s || '')
      .toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[-_]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function normKey(s) {
    // For SPECIAL keyed with hyphens (arc-en-ciel)
    return (s || '')
      .toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  function getLabel(el) {
    var sr = el.querySelector('.sr-only');
    if (sr && sr.textContent) return sr.textContent;
    if (el.getAttribute('data-tooltip')) return el.getAttribute('data-tooltip');
    if (el.getAttribute('aria-label')) return el.getAttribute('aria-label');
    return '';
  }

  function isKitoContext(el) {
    var node = el;
    while (node && node !== document.documentElement) {
      var handle = node.getAttribute && node.getAttribute('handle');
      if (handle && handle.indexOf('kito') !== -1) return true;
      node = node.parentElement;
    }
    return window.location.pathname.indexOf('kito') !== -1;
  }

  function computeBg(label, el) {
    var raw = normKey(label);
    var n = norm(label);
    if (isKitoContext(el) && KITO_SWATCHES[n]) {
      return KITO_SWATCHES[n];
    }
    // 1. Exact compound (ex: "or rose", "marron fonce")
    if (COMPOUND[n]) return COMPOUND[n];
    // 2. Special pattern (single token, may contain hyphens)
    if (SPECIAL[raw]) return SPECIAL[raw];
    if (SPECIAL[n]) return SPECIAL[n];
    // 3. Single word in PALETTE
    var parts = n.split(/\s+/).filter(Boolean);
    if (parts.length === 1 && PALETTE[parts[0]]) return PALETTE[parts[0]];
    // 4. 2-word 50/50 split (ex: "Noir Blanc", "Noir Rouge")
    if (parts.length >= 2) {
      var h1 = PALETTE[parts[0]];
      var h2 = PALETTE[parts[1]];
      if (h1 && h2) {
        return 'linear-gradient(135deg, ' + h1 + ' 0%, ' + h1 + ' 50%, ' + h2 + ' 50%, ' + h2 + ' 100%)';
      }
      // Fallback: if only first word maps, use it solid
      if (h1) return h1;
    }
    return null;
  }

  function applyColorSwatch(el) {
    var bg = computeBg(getLabel(el), el);
    if (!bg) return;
    el.style.setProperty('--swatch-background', bg);
    el.setAttribute('data-pz-combo', '1');
  }

  function applyBlockSwatch(parent) {
    var inner = parent.querySelector('.block-swatch__color');
    var txt = parent.querySelector('span:not(.block-swatch__color)');
    if (!inner || !txt) return;
    var bg = computeBg(txt.textContent, parent);
    if (!bg) return;
    inner.style.setProperty('--swatch-background', bg);
    parent.setAttribute('data-pz-combo', '1');
  }

  function run() {
    document.querySelectorAll('.color-swatch:not([data-pz-combo])').forEach(applyColorSwatch);
    document.querySelectorAll('.block-swatch:not([data-pz-combo])').forEach(applyBlockSwatch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('variant:change', run);
  var mo = new MutationObserver(function () { run(); });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
